import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Terms() {
  const updated = "October 2026";
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 starfield" data-testid="terms-page">
      <header className="border-b border-white/5 bg-slate-950/80 backdrop-blur sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-amber-400" />
            <span className="font-serif text-lg text-slate-50">Cosmic Sage</span>
          </Link>
          <Link to="/dashboard" className="text-sm text-amber-300 hover:text-amber-200">← Back to App</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="font-serif text-4xl text-slate-50 mb-2">Terms of Service</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: {updated}</p>

        <section className="space-y-6 text-slate-300 leading-relaxed">
          <p>
            By using <span className="text-amber-300">cosomicsage.com</span> ("Cosmic Sage", "the Service") you agree to these
            Terms. Please read them carefully. If you do not agree, do not use the Service.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">1. Nature of Service</h2>
          <p>
            Cosmic Sage provides astrology, numerology, and allied Vedic insights for{" "}
            <b>entertainment and self-reflection only</b>. Content is NOT a substitute for professional
            medical, legal, financial, mental health, or relationship advice. Decisions you make based
            on our content are your sole responsibility.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">2. Accounts</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You can use the Service as a guest. If you create an account, you must provide accurate information and keep your password secure.</li>
            <li>You are responsible for all activity on your account.</li>
            <li>We may suspend or terminate accounts that violate these Terms or applicable law.</li>
          </ul>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">3. Acceptable Use</h2>
          <p>You agree NOT to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Reverse-engineer, scrape, or attempt to extract source code.</li>
            <li>Submit palm images of other people without their consent.</li>
            <li>Use the service to harass, defame, or make illegal predictions about third parties.</li>
            <li>Attempt to bypass the ad-reward quota or defraud our advertising partners.</li>
            <li>Resell our content or redistribute it as your own.</li>
          </ul>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">4. Advertising & Monetisation</h2>
          <p>
            Cosmic Sage is free. We fund operations through advertising (Google AdSense and partners)
            and an optional rewarded-ad system that unlocks additional premium readings after you
            watch a short sponsored video. By using the Service you consent to seeing ads and to the
            cookie/data practices described in our <Link to="/privacy" className="text-amber-300 underline">Privacy Policy</Link>.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">5. User Content</h2>
          <p>
            You retain ownership of any content you submit (birth details, palm images, chat
            messages). You grant us a non-exclusive, royalty-free licence to use that content solely
            to deliver the Service to you.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">6. AI-Generated Output</h2>
          <p>
            AI-generated chat replies, palm reading reports, and divisional chart interpretations are
            produced by large language models. They may contain inaccuracies or hallucinated details.
            Treat them as inspiration, not fact. We do not warrant their accuracy.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">7. Disclaimers</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED,
            INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Cosmic Sage, its creators, and partners will not
            be liable for any indirect, incidental, special, consequential, or punitive damages, or
            any loss of profits or revenues, arising out of your use of the Service.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">9. Intellectual Property</h2>
          <p>
            The Service, including its design, logo, charts, and generated reports (except user
            inputs), is owned by Cosmic Sage. You may share screenshots and the generated chart
            images provided they are not altered to remove our branding or disclaimers.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">10. Changes</h2>
          <p>
            We may change these Terms from time to time. Material changes will be announced in-app.
            Continued use after the effective date constitutes acceptance.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India. Any disputes shall be submitted to the
            courts of competent jurisdiction in Mumbai.
          </p>

          <h2 className="font-serif text-2xl text-slate-50 pt-4">12. Contact</h2>
          <p>
            Questions? Email <span className="text-amber-300">support@cosomicsage.com</span>.
          </p>
        </section>

        <footer className="mt-12 pt-6 border-t border-white/5 text-sm text-slate-500 flex flex-wrap gap-4">
          <Link to="/" className="hover:text-amber-300">Home</Link>
          <Link to="/privacy" className="hover:text-amber-300">Privacy Policy</Link>
          <Link to="/about" className="hover:text-amber-300">About</Link>
        </footer>
      </main>
    </div>
  );
}
